import { ReactNode } from "react";
import AdminLayout from "../shared/AdminLayout";
import { useIntl, FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { usAdminAppRoutes } from "../../../route-definitions";
import BaseFilters from "../shared/components/BaseFilters";
import { ButtonConfig } from "../shared/components/HeaderButtons";
import BaseFilterChip from "../shared/components/FilterChip";
import { FilterOption } from "../shared/components/BaseFilters";
import HeaderSearchInput from "../shared/components/HeaderSearch";
import { getMainFilterOptions } from "./distributor.constants";
import { getDistributorFilters } from "./services/distributor-service";

interface Props {
  children: ReactNode;
  searchInput: string;
  onSearchInputChange: (value: string) => void;
  onFilterChange: (
    mainFilter: FilterOption | null,
    subcategory: FilterOption | null
  ) => void;
  appliedFilters: Record<string, string>;
  onRemoveFilter: (filterKey: string) => void;
}

function DistributorPageLayout({
  children,
  searchInput,
  onSearchInputChange,
  onFilterChange,
  appliedFilters,
  onRemoveFilter,
}: Props) {
  const intl = useIntl();
  const history = useHistory();

  function handleButtonClick() {
    history.push(usAdminAppRoutes.createDistributor);
  }

  const headerButtons: ButtonConfig[] = [
    {
      id: "add-distributor-button",
      text: intl.formatMessage({ id: "usAdmin.addDistributor" }),
      backgroundColor: "green",
      handleClick: handleButtonClick,
      className: "",
    },
  ];

  const mainFilterOptions = getMainFilterOptions(intl);

  return (
    <AdminLayout
      header={<FormattedMessage id="usAdmin.distributor" />}
      headerButtons={headerButtons}
      headerActions={
        <div className="usadmin-admin-layout">
          <div className="usadmin-header-actions">
            <HeaderSearchInput
              searchInput={searchInput}
              onSearchInputChange={onSearchInputChange}
              placeholder={intl.formatMessage({
                id: "usAdmin.searchByAllFields",
              })}
            />
            <BaseFilters
              onFilterChange={onFilterChange}
              onRemoveFilter={onRemoveFilter}
              mainFilterOptions={mainFilterOptions}
              fetchOptions={getDistributorFilters}
              filterLabel={intl.formatMessage({ id: "usAdmin.filter" })}
              selectCategoryPlaceholder={intl.formatMessage({
                id: "usAdmin.selectCategory",
              })}
            />
          </div>
          <BaseFilterChip
            appliedFilters={appliedFilters}
            onRemoveFilter={onRemoveFilter}
            mainFilterOptions={mainFilterOptions}
          />
        </div>
      }
      containerClassName="usadmin-entities-main-container"
    >
      {children}
    </AdminLayout>
  );
}

export default DistributorPageLayout;
